export const getCompanyName = () => '«Лучи»';
export const getCompanyFullName = () => 'ООО Лучи Здоровье';
